import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData';

function UnitAct() {
    return (
        <SettingsMetaData propertyName={"UnitAct"} viewPropertyName={"Unit"} />
      );
}

export default UnitAct
